import axios from "./config";

export const generarLinksPago = async () => {
  const { data, status } = await axios
    .post("/facturacion")
    .catch((e) => e.response);
  return { data, status };
};

export const ejecutarCartera = async () => {
  const { data, status, headers } = await axios
    .post("/facturacion/cartera", null, { responseType: "blob" })
    .catch((e) => e.response);
  return { data, status, headers };
};
